import React from 'react';
import { useTranslation } from '../i18n';

interface TermsAcceptanceProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export const TermsAcceptance: React.FC<TermsAcceptanceProps> = ({ checked, onChange, disabled }) => {
  const { t } = useTranslation();

  return (
    <div className="form-group">
      <label style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem', fontSize: '0.9rem', cursor: 'pointer' }}>
        <input
          type="checkbox"
          checked={checked}
          onChange={e => onChange(e.target.checked)}
          required
          disabled={disabled}
          aria-required="true"
          style={{ marginTop: '0.2rem' }}
        />
        <span>
          {t('login.terms_accept_prefix')}{' '}
          {/* New tab so the half-filled registration form is not lost. */}
          <a href="/terms" target="_blank" rel="noopener noreferrer">{t('login.terms_accept_link')}</a>
        </span>
      </label>
    </div>
  );
};

/** Optional, unchecked by default: marketing consent must be freely given and separate from the terms. */
export const MarketingConsentCheckbox: React.FC<TermsAcceptanceProps> = ({ checked, onChange, disabled }) => {
  const { t } = useTranslation();

  return (
    <div className="form-group">
      <label style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem', fontSize: '0.9rem', cursor: 'pointer' }}>
        <input
          type="checkbox"
          checked={checked}
          onChange={e => onChange(e.target.checked)}
          disabled={disabled}
          style={{ marginTop: '0.2rem' }}
        />
        <span>{t('marketing_consent.label')}</span>
      </label>
    </div>
  );
};
